import React, { useEffect, useMemo, useState } from "react";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { useConsolidationExportUIContext } from "../../ConsolidationExportUIContext";
import {
  initialFilter,
  ORGANIZATION_REPORT_STATUS
} from "../../ConsolidationExportUIHelpers";
import AsyncSelect from "react-select/async";
import { genOptionLoaderParams } from "../../../../../../../_metronic/_helpers/fetchUtils";
import { findorganization } from "../../../../_redux/organization/organizationCrud";
import { Select } from "../../../../../../../_metronic/_partials/controls";
import { generateYearsBetween } from "../../../../../../config/helper";

const prepareFilter = (queryParams, values) => {
  const { year, month, is_consolidated } = values;
  const newQueryParams = { ...queryParams };
  const filter = {};

  //add to Object filter
  newQueryParams.is_consolidated = is_consolidated ?? "";
  newQueryParams.year = year ?? "";
  newQueryParams.month = month ?? "";

  return newQueryParams;
};

export const ConsolidationExportFilter = ({ listLoading }) => {
  // ConsolidationExport UI Context
  const ConsolidationExportUIContext = useConsolidationExportUIContext();
  const ConsolidationExportUIProps = useMemo(() => {
    return {
      setQueryParams: ConsolidationExportUIContext.setQueryParams,
      queryParams: ConsolidationExportUIContext.queryParams,
      filterType: ConsolidationExportUIContext.filterType
    };
  }, [ConsolidationExportUIContext]);

  const [defaultOptions, setDefaultOptions] = useState({
    organizations: []
  });

  useEffect(() => {
    findorganization({
      page1umber: 1,
      pageSize: 10,
      filter: {}
    }).then(res => {
      const { data } = res.data;
      const options = data.items.map(item => ({
        label: item.name,
        value: item.uuid
      }));
      setDefaultOptions(prev => ({
        ...prev,
        organizations: options
      }));
    });
  }, []);

  const applyFilter = values => {
    const newQueryParams = prepareFilter(
      ConsolidationExportUIProps.queryParams,
      values
    );
    if (!isEqual(newQueryParams, ConsolidationExportUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      ConsolidationExportUIProps.setQueryParams(newQueryParams);
    }
  };

  const [currentTimeout, setCurrentTimeout] = useState(null);

  const currentYear = new Date().getFullYear();
  const years = generateYearsBetween(currentYear - 5, currentYear);
  const months = Array.from({ length: 12 }, (e, i) => {
    let data = {};
    data.label = new Date(null, i + 1, null).toLocaleDateString("id", {
      month: "long"
    });
    data.value = i + 1;

    return data;
  });

  const isConsolidated = [
    {
      label: "Sudah Konsolidasi",
      value: true
    },
    {
      label: "Belum Konsolidasi",
      value: false
    }
  ];

  return (
    <Formik
      initialValues={initialFilter}
      onSubmit={values => {
        applyFilter(values);
      }}
    >
      {({ values, handleSubmit, handleBlur, setFieldValue }) => (
        <form onSubmit={handleSubmit} className="form form-label-right">
          <div className="form-group row">
            <div className="col-lg-4">
              <label>
                <strong>Pilih Tahun</strong>
              </label>
              <Select
                name="year"
                onChange={e => {
                  setFieldValue(e.target.name, e.target.value);
                  handleSubmit();
                }}
                onBlur={handleBlur}
              >
                <option value={""}>-</option>
                {years.map(year => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </Select>
            </div>
            <div className="col-lg-4">
              <label>
                <strong>Pilih Bulan</strong>
              </label>
              <Select
                name="month"
                onChange={e => {
                  setFieldValue(e.target.name, e.target.value);
                  handleSubmit();
                  // handleChangeFilter(e.target.name, e.target.value);
                }}
                onBlur={handleBlur}
              >
                <option value={""}>SEMUA</option>
                {months.map(month => (
                  <option key={month} value={month.value}>
                    {month.label.toUpperCase()}
                  </option>
                ))}
              </Select>
            </div>
            <div className="col-lg-4">
              <label>
                <strong>Status Konsolidasi</strong>
              </label>
              <Select
                name="is_consolidated"
                onChange={e => {
                  setFieldValue(e.target.name, e.target.value);
                  handleSubmit();
                  // handleChangeFilter(e.target.name, e.target.value);
                }}
                onBlur={handleBlur}
              >
                {isConsolidated.map(consolidated => (
                  <option key={consolidated.value} value={consolidated.value}>
                    {consolidated.label.toUpperCase()}
                  </option>
                ))}
              </Select>
            </div>
            {/* <div className="col-lg-4">
              <label>
                <strong>Pilih Bulan</strong>
              </label>
              <Select
                name="month"
                onChange={e => {
                  setFieldValue(e.target.name, e.target.value);
                }}
                onBlur={handleBlur}
              >
                <option value={""}>-</option>

                {months.map(month => (
                  <option key={month} value={month.value}>
                    {month.label.toUpperCase()}
                  </option>
                ))}
              </Select>
            </div> */}
          </div>
          {/* <div className="form-group row">
            <div className="col">
              <button
                className="btn btn-warning float-right"
                onClick={handleSubmit}
              >
                Terapkan
              </button>
            </div>
          </div> */}
        </form>
      )}
    </Formik>
  );
};
